var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrnamentBuy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 318,
    height: 576,
    viewBox: "0 0 318 576",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M318 576V456.078L159 357.517L2.77533e-05 456.078L2.2508e-05 576L159 477.439L318 576Z",
    fill: "#F6F6F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M318 277.319V397.241L159 298.681L0 397.241L5.24537e-06 277.319L159 178.759L318 277.319Z",
    fill: "#F6F6F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M318 98.5608V218.483L159 119.922L7.81887e-06 218.483L1.30642e-05 98.5608L159 0L318 98.5608Z",
    fill: "#F6F6F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrnamentBuy);
export default __webpack_public_path__ + "static/media/ornament-buy.bc5d6285c822e17c3a04359cbae50f42.svg";
export { ForwardRef as ReactComponent };